export default __webpack_public_path__ + "static/affiliate-program-AffiliateApp@2x-8061aa2ed522db581a867e476598989e.webp";